<template>
	<div>
		<v-row
			class="px-6 mt-3 mt-md-6"
			justify="space-around"
		>
			<v-col
				cols="12"
				md="4"
			>
				<v-card
					elevation="6"
				>
					<v-img
						height="250"
						:src="require('@/assets/gifts.png')"
					></v-img>
					<v-card-title>
						Amazon
					</v-card-title>
					<v-card-text>
						Buy a Gift
					</v-card-text>
					<v-card-actions>
						<v-btn
							link
							color="primary"
							style="color: black"
							target="_blank"
							href="https://www.amazon.com/wedding/share/onemoreschwartz"
						>
							Go to the Registry
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
			<v-col
				cols="12"
				md="4"
			>
				<v-card
					elevation="6"
				>
					<v-img
						height="250"
						:src="require('@/assets/maldives.png')"
					></v-img>
					<v-card-title>
						Honeymoon Fund
					</v-card-title>
					<v-card-text>
						Help Fund the Honeymoon
					</v-card-text>
					<v-card-actions>
						<v-btn
							link
							color="primary"
							style="color: black"
							target="_blank"
							href="https://www.honeyfund.com/site/patterson-schwartz-09-01-2023"
						>
							Go to the Fund
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
		<br/>
	</div>
</template>

<script>
	export default {
		name: "Registry"
	}
</script>

<style scoped>

</style>
